<template>
  <div class="choose-party">
    <div
      class="choose-party-template"
      v-for="(data,i) in partyBranchs"
      :key="i"
      v-show="data.show"
    >
      <el-select
        v-model="data.value"
        :placeholder="data.placeholder"
        @change="partyChange"
        @focus="Fchoose(i)"
      >
        <el-option v-for="item in data.datas" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      partyBranchs: [
        {
          value: "",
          datas: [],
          name: "",
          placeholder: "选择一级党支部",
          show: true
        },
        {
          value: "",
          datas: [],
          name: "",
          placeholder: "选择二级党支部",
          show: false
        },
        {
          value: "",
          datas: [],
          name: "",
          placeholder: "选择三级党支部",
          show: false
        },
        {
          value: "",
          datas: [],
          name: "",
          placeholder: "选择四级党支部",
          show: false
        }
      ],
      choose: -1
    };
  },
  methods: {
    Fchoose(index) {
      this.choose = index;
    },
    partyChange(e) {
      this.partyBranchs[this.choose].value = e;
      this.partyBranchs[this.choose].datas.filter(item => {
        if (item.id === e) {
          this.partyBranchs[this.choose].name = item.name;
        }
      });
      this.getMsg(this.choose + 1);
      this.$emit('change-party',this.partyBranchs)
    },
    getMsg(number) {
      let name = ["OneParty", "TwoParty", "ThreeParty", "FourParty"];
      let url;
      number > 0
        ? (url = `/api/Login/${name[number]}?id=${this.partyBranchs[number - 1].value}`)
        : (url = `/api/Login/${name[number]}`);
      for (let x = 3; x >= number; x--) {
        this.partyBranchs[x].datas = [];
        this.partyBranchs[x].value = "";
        this.partyBranchs[x].name = "";
        this.partyBranchs[x].show = false;
      }

      this.axios.get(url).then(e => {
        if (e.data.code === 0) {
          if (e.data.msg.length > 0) {
            this.partyBranchs[number].show = true;
            e.data.msg.filter(item => {
              //  console.log(item);
              this.partyBranchs[number].datas.push({
                name: item[`c${number + 1}name`],
                id: item[`c${number + 1}id`]
              });
            });
          }
        }
      });
    },
  },
  mounted() {
    this.getMsg(0);
  }
};
</script>

<style lang='scss' scoped>
.choose-party {
  &-template {
    margin-top: 8px;
  }
  font-size: 0.3rem;
}
</style>